/**
 * Created by kirandogra on 24/07/18.
 */
App.controller('documentsController',[ '$scope','API','$location','$http','driverService','$mdToast','$rootScope','$filter',function( $scope,API,$location,$http,driverService,$mdToast,$rootScope,$filter){

    history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };
    document.getElementById('logoShap').style.pointerEvents = 'none';

    var toast;
    $scope.imageuploading = false;
    $rootScope.loading_custom = false;
    $scope.driverProfileData = JSON.parse(localStorage.getItem('loginData'))

    function fetchDocumentsList(){

        driverService.fetchDriverDocuments().then(function(res){
            if(res.data.flag == responseStatus.SUCCESS) {
                $scope.driver_documents = res.data.data;
                if ($scope.selectedDoc) {
                    for (var val  in $scope.driver_documents) {
                        if ($scope.selectedDoc.doc_type_num == $scope.driver_documents[val].doc_type_num) {
                            $scope.selectedDoc = $scope.driver_documents[val];
                        }
                    }
                    if ($('#imageModal').hasClass('in')) {
                        $scope.openImagesModal($scope.selectedDoc);
                    }
                }
            }
            else if(res.data.flag == responseStatus.SESSION_EXPIRED){
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
        })
    }
    fetchDocumentsList();

    $scope.getDocID = function(doc){
        $scope.selectedDoc = doc
    }

    $scope.imageToUpload = function (File) {
        $scope.image_uploaded = File[0];
        if ($scope.image_uploaded.name.indexOf('.png') == -1 && $scope.image_uploaded.name.indexOf('.jpeg') == -1 && $scope.image_uploaded.name.indexOf('.jpg') == -1 && $scope.image_uploaded.name.indexOf('.PNG') == -1 && $scope.image_uploaded.name.indexOf('.JPG') == -1 && $scope.image_uploaded.name.indexOf('.JPEG') == -1) {
            $scope.errorFlag = true;
            createToast('warning','File Type Should be .png or .jpeg only');
            //$scope.$apply();
            return;
        }
        if ($scope.image_uploaded.size) {
            var fileSize = $scope.image_uploaded.size / 1024; // in bytes
            if (fileSize > 2048) {
                createToast('warning','File size cannot be more than ' + 2 + ' MB');
                //alert('file size cannot be more than ' + 2 + ' MB');
                return false;
            }
        }
        var img_position = -1;
        for (var val in $scope.selectedDoc.doc_url)
        {
            if( !$scope.selectedDoc.doc_url[val]) {
                img_position = val;
                break;
            }
        }
        img_position = (img_position == -1) ? 0 : img_position;

        $scope.errorFlag = false;
        var formData = new FormData();
        formData.append("image", $scope.image_uploaded);
        formData.append("doc_type_num", $scope.selectedDoc.doc_type_num);
        formData.append("img_position",img_position );

        driverService.uploadDocuments(formData).then(function(res){
            if(res.data.flag == responseStatus.SUCCESS){
                fetchDocumentsList();
            }
            else {
                createToast('warning','Something went wrong');
            }

        })

    };


    $scope.removeDocument = function(key){
        var reqObj = {
            img_position: key,
            doc_type_num: $scope.selectedDoc.doc_type_num

        }
        driverService.deleteDocument(reqObj).then(function(res){
            fetchDocumentsList();

        })

    }

    $scope.completeRegisteration = function(){
        var reqObj = {
            login_documents: 3
        }
        driverService.completeRegisteration(reqObj).then(function(res){
            if(res.data.flag == responseStatus.SUCCESS){
                $('#thankyouModal').modal('show');
            }
            else {
                createToast('warning',res.data.message);
            }
        })
    }
    $scope.backToHomepage = function (){
        $('#thankyouModal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $location.path('/')
    }
    function createToast(type,content) {
        if(toast)  $mdToast.hide();
        toast = $mdToast.show($mdToast.simple().position('bottom left').textContent(content));
    }

    $scope.openImagesModal = function (doc){
        $scope.selectedDoc = doc
        if($filter('documentsFilter')( $scope.selectedDoc.doc_status) != 'Rejected' ||  $scope.selectedDoc.is_editable  ){
            document.getElementById('imageUploadDiv').style.pointerEvents = 'none';
        }
        else{
            document.getElementById('imageUploadDiv').style.pointerEvents = 'auto';
        }
        $scope.selectedImages = doc.doc_url;
        document.getElementById('right').style.display = 'block';
        document.getElementById('left').style.display = 'none';

        $scope.currentIndex = 0;
        target.src = $scope.selectedImages[0];
        $('#imageModal').modal('show');

    }

    $scope.nextPic = function(){
        $scope.currentIndex = 1
        target.src = $scope.selectedImages[1];
        document.getElementById('right').style.display = 'none';
        document.getElementById('left').style.display = 'block';

    }
    $scope.prevPic = function(){
        $scope.currentIndex = 0;
        target.src = $scope.selectedImages[0];
        document.getElementById('left').style.display = 'none';
        document.getElementById('right').style.display = 'block';

    }

    //$scope.imageToUpload = function (File) {
    //    $scope.image_uploaded = File[0];
    //    if ($scope.image_uploaded.name.indexOf('.png') == -1 && $scope.image_uploaded.name.indexOf('.jpeg') == -1 && $scope.image_uploaded.name.indexOf('.jpg') == -1 && $scope.image_uploaded.name.indexOf('.PNG') == -1 && $scope.image_uploaded.name.indexOf('.JPG') == -1 && $scope.image_uploaded.name.indexOf('.JPEG') == -1) {
    //        $scope.errorFlag = true;
    //        createToast('warning','File Type Should be .png or .jpeg only');
    //        //$scope.$apply();
    //        return;
    //    }
    //    if ($scope.image_uploaded.size) {
    //        var fileSize = $scope.image_uploaded.size / 1024; // in bytes
    //        if (fileSize > 2048) {
    //            createToast('warning','File size cannot be more than ' + 2 + ' MB');
    //            //alert('file size cannot be more than ' + 2 + ' MB');
    //            return false;
    //        }
    //    }
    //    var img_position = -1;
    //    for (var val in $scope.selectedDoc.doc_url)
    //    {
    //        if( !$scope.selectedDoc.doc_url[val]) {
    //            img_position = val;
    //            break;
    //        }
    //    }
    //    img_position = (img_position == -1) ? 0 : img_position;
    //
    //    $scope.errorFlag = false;
    //    var formData = new FormData();
    //    formData.append("image", $scope.image_uploaded);
    //    formData.append("doc_type_num", $scope.selectedDoc.doc_type_num);
    //    formData.append("img_position",img_position );
    //
    //    driverService.uploadDocuments(formData).then(function(res){
    //        if(res.data.flag == responseStatus.SUCCESS){
    //            fetchDocumentsList();
    //        }
    //        else {
    //            createToast('warning','Something went wrong');
    //        }
    //
    //    })
    //
    //};
    function uploadImage(file){
        var img_position = -1;
        for (var val in $scope.selectedDoc.doc_url) {
            if (!$scope.selectedDoc.doc_url[val]) {
                img_position = val;
                break;
            }
        }
        img_position = (img_position == -1) ? 0 : img_position;

        $scope.errorFlag = false;
        var formData = new FormData();
        formData.append("image", file);
        formData.append("doc_type_num", $scope.selectedDoc.doc_type_num);
        formData.append("img_position", img_position);

        driverService.uploadDocuments(formData).then(function (res) {
            $scope.imageuploading = false;
            if (res.data.flag == responseStatus.SUCCESS) {
                fetchDocumentsList();
            }
            else if (res.data.flag == responseStatus.SESSION_EXPIRED) {
                createToast('warning', 'Your login session has expired. Please try again');
                $location.path('/');
            }
            else {
                createToast('warning', 'Something went wrong');
            }

        })
    }

    $scope.imageToUpload = function (File) {
        $scope.image_uploaded = File[0];
        $scope.imageuploading = true;

        if ($scope.image_uploaded.name.indexOf('.png') == -1 && $scope.image_uploaded.name.indexOf('.jpeg') == -1 && $scope.image_uploaded.name.indexOf('.jpg') == -1 && $scope.image_uploaded.name.indexOf('.PNG') == -1 && $scope.image_uploaded.name.indexOf('.JPG') == -1 && $scope.image_uploaded.name.indexOf('.JPEG') == -1) {
            $scope.errorFlag = true;
            createToast('warning','File Type Should be .png or .jpeg only');
            //$scope.$apply();
            return;
        }
        if ($scope.image_uploaded.size) {
            var fileSize = $scope.image_uploaded.size / 1024; // in bytes
            if (fileSize > 2048) {
                var reader = new FileReader();
                // Set the image once loaded into file reader
                reader.onload = function(e)
                {
                    var img = document.createElement("img");
                    img.src = e.target.result;
                    img.addEventListener('load', function () {
                        var canvas = document.createElement("canvas");
                        var canvasDraw = canvas.getContext("2d");
                        canvasDraw.drawImage(img, 0, 0);
                        var MAX_WIDTH = 800;
                        var MAX_HEIGHT = 700;
                        var width = img.width;
                        var height = img.height;

                        if (width > height) {
                            if (width > MAX_WIDTH) {
                                height *= MAX_WIDTH / width;
                                width = MAX_WIDTH;
                            }
                        }
                        else {
                            if (height > MAX_HEIGHT) {
                                width *= MAX_HEIGHT / height;
                                height = MAX_HEIGHT;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        var canvasDraw = canvas.getContext("2d");
                        canvasDraw.drawImage(img, 0, 0, width, height);

                        var imageUrl = canvas.toDataURL("image/png");

                        var blobBin = atob(imageUrl.split(',')[1]);
                        var array = [];
                        for (var i = 0; i < blobBin.length; i++) {
                            array.push(blobBin.charCodeAt(i));
                        }
                        var file = new Blob([new Uint8Array(array)], {type: 'image/png'});

                        uploadImage(file)
                    })

                }
                // Load files into file reader
                reader.readAsDataURL($scope.image_uploaded);
            }
            else{
                uploadImage($scope.image_uploaded)
            }

        }


    };

    $scope.getDocID = function(doc){
        $scope.selectedDoc = doc
    }
    $scope.uploadDocMetaData = function (docInfo){
        var doc_values = [];
        for(var info in docInfo){
            doc_values.push({key: docInfo[info].key, value: docInfo[info].value});
        }
        var reqObj = {
            doc_values: JSON.stringify(doc_values),
            doc_type_num: $scope.selectedDoc.doc_type_num
        }
        driverService.uploadDocumentsMetaData(reqObj).then(function (res) {
            if(res.data.flag == responseStatus.SUCCESS){
                $('#imageModal').modal('hide');
            }
            else {
                createToast('warning',res.data.error);
            }
        })

    }

}])